const pattern = /^(New session|Child session) - \d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/

interface Info {
  readonly title?: string
  readonly parentID?: string
  readonly time: {
    readonly created: number
  }
}

export function withTimestampedFallback(info: Info) {
  return info.title ?? `${info.parentID ? "Child" : "New"} session - ${new Date(info.time.created).toISOString()}`
}

export function sessionTitle(title?: string) {
  if (!title) return title
  const match = title.match(pattern)
  return match?.[1] ?? title
}

// 是否为默认标题（"New session - <iso>" / "Child session - <iso>"）。
// 与后端 Session.isDefaultTitle 等价：创建会话时未传 title 则写入该默认值，
// 首条用户消息后会被 prompt.ts 自动 setTitle 覆盖，因此 default 标题即"没有任何消息的会话"。
export function isDefaultSessionTitle(title?: string): boolean {
  return !!title && pattern.test(title)
}
